import { render, staticRenderFns } from "./DriverQuickActions.vue?vue&type=template&id=dcca31f0&scoped=true"
import script from "./DriverQuickActions.vue?vue&type=script&lang=js"
export * from "./DriverQuickActions.vue?vue&type=script&lang=js"
import style0 from "./DriverQuickActions.vue?vue&type=style&index=0&id=dcca31f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcca31f0",
  null
  
)

export default component.exports